import React, { useState } from "react";
import {
  Box,
  Collapse,
  IconButton,
  Typography,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Table,
  Button,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import { IoIosAddCircle } from "react-icons/io";
import { Link } from "react-router-dom";
import CustomModal from "../../../common/custom-modal";
import Data from "../../../common/custom-modal/Data";
import {ability} from "../../../../config/acl/ability";

const DataTable = ({
  service,
  onDelete,
  onAddType,
  onEditType,
  onDeleteType,
}) => {
  const [openSubTable, setOpenSubTable] = useState(false);
  const can_edit_service = ability.can('ourServices','update')
  const can_add_type = ability.can('ourServicesTypes','store')
  const can_edit_type = ability.can('ourServicesTypes','update')
  const can_delete_type = ability.can('ourServicesTypes','destroy')
  return (
    <>
      <TableRow>
        <TableCell>
          {
            service.with_type &&
            <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpenSubTable(!openSubTable)}
            >
              {openSubTable ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          }

        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {service.name}
        </TableCell>
        <TableCell align="center">
          <Data data={service?.description} />
        </TableCell>
        <TableCell align="center">
          <span
            className={`badge text-darkTextColor ${
              service.FiledImage ? "bg-[#28a745]" : "bg-[#ff6877]"
            }`}
          >
            {service.FiledImage ? "active" : "inactive"}
          </span>
        </TableCell>
        <TableCell align="center">
          <span
            className={`badge text-darkTextColor ${
              service.FiledTitle ? "bg-[#28a745]" : "bg-[#ff6877]"
            }`}
          >
            {service.FiledTitle ? "active" : "inactive"}
          </span>
        </TableCell>
        <TableCell align="center">
          <span
            className={`badge text-darkTextColor ${
              service.FiledDescription ? "bg-[#28a745]" : "bg-[#ff6877]"
            }`}
          >
            {service.FiledDescription ? "active" : "inactive"}
          </span>
        </TableCell>
        {/* <TableCell align="center">
                      <img className="max-w-28 max-h-12" src={service.picture} alt="Service" />
                  </TableCell> */}
        <TableCell align="center">
          <span
            className={`badge text-darkTextColor ${
              service.active ? "bg-[#28a745]" : "bg-[#ff6877]"
            }`}
          >
            {service.active ? "active" : "inactive"}
          </span>
        </TableCell>
        <TableCell align="center" component="th" scope="row">
          {service.order}
        </TableCell>
        <TableCell align="center">
          <div className="flex gap-x-10 text-lg items-center justify-center">
            {
              can_add_type &&
              service.with_type &&
              <IoIosAddCircle
                  onClick={() => onAddType(service.id)}
                  className="text-primary cursor-pointer"
              />
            }
            {
              can_edit_service &&
              <Link
                  to={`/Edit-AD/${service.id}`}
                  color="inherit"
                  underline="none"
              >
                <FaPencilAlt className="text-[#6c757d]" />
              </Link>
            }

            {/* <FaTrashAlt
              onClick={() => onDelete(service.id)}
              className="text-[#d9534f] cursor-pointer"
            /> */}
          </div>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
          <Collapse in={openSubTable} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, width: "100%" }}>
              <Typography variant="h6" gutterBottom component="div">
                Types
              </Typography>
              {service.type.length > 0 && service.with_type ? (
                <Table size="large" aria-label="types">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Type</TableCell>
                      <TableCell align="center">days</TableCell>
                      <TableCell align="center">Price</TableCell>
                      <TableCell align="center">count ticket</TableCell>
                      <TableCell align="center">Order</TableCell>
                      <TableCell align="center">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {service.type.map((type) => (
                      <TableRow key={type.id}>
                        <TableCell align="center">{type.type}</TableCell>
                        <TableCell align="center">{type.days}</TableCell>
                        <TableCell align="center">${type.price}</TableCell>
                        <TableCell align="center">{type.countTicket}</TableCell>
                        <TableCell align="center">{type.order}</TableCell>
                        <TableCell align="center">
                          <div className="flex gap-x-10 items-center justify-center">
                            {
                              can_edit_type &&
                              <FaPencilAlt
                                  onClick={() => onEditType(type)}
                                  className="text-[#6c757d] cursor-pointer"
                              />
                            }
                            {
                              can_delete_type &&
                              <FaTrashAlt
                                  onClick={() => onDeleteType(type.id)}
                                  className="text-[#d9534f] cursor-pointer"
                              />
                            }


                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>No types available</Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default DataTable;
